import ExamplePanel from './ExamplePanel';
import React from 'react';
import { Heading, Section, SectionHeader } from 'rebass';

export default function InfoSection() {
  return (
    <Section>
      <SectionHeader heading="Spoonerisms by example" />
      <p>
        These examples demonstrate the spoonerizing algorithm used bt the
        spoonerism generator on this page. But remember there aren{'\''}t any
        hard and fast rules in word play! If it{'\''}s funny, then it{'\''}s a
        correct answer!
      </p>
      <Heading mt={4}>
        The basics
      </Heading>
      <p>
        The easiest spoonerisms are created from two words which both begining
        with consonant sounds.
      </p>
      <ExamplePanel
        phrase="Hello Kitty"
        title="A simple spoonerism"
      />
      <p>
        To spoonerize phrases with more than two words, replace the begining
        sound of each word with the begining sound of the previous word.
      </p>
      <ExamplePanel
        title="A three word spoonerism"
        phrase="Red, White, Blue"
      />
      <Heading mt={4}>
        Unspoonerable phrases
      </Heading>
      <p>
        Sadly, it just isn{'\''}t possible to spoonerize every phrase.
        Often when each word in a phrase begins with the same sound, the phrase
        is unspoonerable.
      </p>
      <ExamplePanel
        title="An unspoonerable phrase"
        phrase="Wonder Woman"
        theme="error"
      />
    </Section>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/ExamplesSection.js
 **/